<template>
	<router-link
		class="navigation__link-item"
		:to="to"
		@click="navigation.close()">
		<FontAwesomeIcon
			class="navigation__link-icon"
			:icon="`${icon}`" />
		<div class="navigation__link-title">{{ title }}</div>
	</router-link>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue'
import { useNavigationStore } from '@/stores/Navigation'

defineProps<{
	to: RouteLocationRaw
	icon: string
	title: string
}>()

const navigation = useNavigationStore()
</script>

<style scoped lang="scss">
.navigation__link-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 9px 12px;
	color: var(--p-text-muted-color);
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	border-radius: 8px;
	transition:
		background-color 0.15s ease,
		color 0.15s ease;

	&:hover {
		background-color: var(--p-surface-100);
		color: var(--p-text-color);

		@media (prefers-color-scheme: dark) {
			background-color: var(--p-surface-800);
		}
	}

	&:focus-visible {
		outline: 2px solid var(--p-primary-500);
		outline-offset: 1px;
	}

	&.router-link-active {
		background-color: var(--p-primary-50);
		color: var(--p-primary-800);
		font-weight: 600;

		@media (prefers-color-scheme: dark) {
			background-color: color-mix(in srgb, var(--p-primary-400) 16%, transparent);
			color: var(--p-primary-200);
		}

		.navigation__link-icon {
			color: var(--p-primary-700);

			@media (prefers-color-scheme: dark) {
				color: var(--p-primary-300);
			}
		}
	}

	.navigation__link-title {
		flex: 1;
	}

	.navigation__link-icon {
		font-size: 17px;
		width: 20px;
		display: flex;
		justify-content: center;
		color: var(--p-text-muted-color);
	}
}
</style>
